import angular from 'angular';
import template from './template.html';
import './style.scss';
import BaseComponent from '../../../../base/component';

const searchGroups = {
    bestMatch: 'Best Match',
    goodMatch: 'Good Match',
    likelyMatch: 'Likely Match',
    lowMatch: 'Low Match',
    nonsense: '<input query>',
};

export class PredictionScore extends BaseComponent {
    $onChanges() {
        if (this.matchSearchGroupData){
            this.$scope.circleClass = this.getCircleClass(this.matchSearchGroupData);
            this.$scope.label = this.getLabel(this.matchSearchGroupData.groupName);
        }
    }

    getCircleClass({ groupName }) {
        switch (groupName) {
            case searchGroups.bestMatch:
                return 'full';
            case searchGroups.goodMatch:
                return 'three-fourth';
            case searchGroups.likelyMatch:
                return 'half';
            case searchGroups.lowMatch:
                return 'one-fourth';
            case searchGroups.nonsense:
                return 'one-fourth';
            default:
                return '';
        }
    }

    getLabel(groupName) {
        if (groupName === searchGroups.nonsense) {
            return 'Low Match';
        }

        return groupName;
    }
}

export const config = {
    template,
    bindings: {
        selfIndex: '<',
        matchSearchGroupData: '<',
    },
    controller: PredictionScore,
    controllerAs: 'ctrl',
};

angular.module('TALENYA-FE').component('matchedSearchGroupIcon', config);
